import StartRecordIcon from "@/assets/simulInter/start_record.svg?react";
import StartRecordViewImg from "@/assets/simulInter/start_record_view.png";
import { ControllerStatus } from "@/types/simulInter";
import { controlUnStartedBoard } from "@/services/simulInter";
import { useControlWebSocket } from "@/hooks/useControlWebSocket";
import deviceStore from "@/store/device.store";
import { message } from "antd";
import { useState, useRef } from "react";
import IcRecordFinishLoading from "@/assets/images/ic_record_finish_loading.png";
import StartRecordErrorDialog, {
  StartRecordErrorDialogRef,
} from "../StartRecordErrorDialog";

interface ControlStartViewProps {
  originStreamName: string;
  onStartRecordSuccess: (streamName: string) => void;
  deviceSn?: string;
}

const ControlStartView = ({
  originStreamName,
  onStartRecordSuccess,
  deviceSn
}: ControlStartViewProps) => {


  // 直接使用单例 Hook
  const { startRecording: wsStartRecording } = useControlWebSocket();
  const [loading, setLoading] = useState(false);
  const errorDialogRef = useRef<StartRecordErrorDialogRef>(null);

  const handleStartRecord = async () => {
    console.log("handleStartRecord", loading);
    setLoading(true);

    try {
      // 1. 检查设备连接状态
      const { connectionInfo, isDeviceAvailable, wsConnected } =
        deviceStore.getState();
      console.log("connectionInfo", connectionInfo);
      if (!connectionInfo || !isDeviceAvailable()) {
        message.error("设备未连接，请先连接设备");
        setLoading(false);
        return;
      }

      if (!wsConnected) {
        message.error("连接已断开，请返回重新连接");
        setLoading(false);
        return;
      }

      // 2. 调用后端控制接口
      console.log("调用后端控制接口");
      const res = await controlUnStartedBoard({
        originStreamName,
        controllerStatus: ControllerStatus.PENDING,
        boardSn: deviceSn || undefined, // 只在有值时传递
      });

      const { streamName } = res.data;
      console.log("后端控制接口调用成功:", streamName);

      // 3. 通过 WebSocket 发送开始录制指令，传递 streamName，等待响应
      console.log("通过 WebSocket 发送开始录制指令，streamName:", streamName);
      const result = await wsStartRecording(streamName);

      console.log("WebSocket 启动录制响应:", result);

      // 4. 根据响应结果处理
      if (result.success && result.status === 'recording_started') {
        onStartRecordSuccess(result.streamName || streamName);
      } else {
        const errorMessage = getErrorMessage(result.status, result.message);
        errorDialogRef.current?.show(result.status, errorMessage);
      }
    } catch (error) {
      console.error("启动录制失败:", error);
      // 异常情况也显示弹框
      errorDialogRef.current?.show('unknown_error', '启动录制失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  // 根据状态码获取错误提示信息
  const getErrorMessage = (status: string, defaultMessage: string): string => {
    const errorMessages: Record<string, string> = {
      'in_summary_page': '设备正处于上一场会议录制的总结页面，是否关闭该页面？',
      'crashed': '应用处于崩溃恢复状态，请前往大屏处理',
      'no_rights': '当前大屏设备「会议纪要」权益已失效，请前往大屏购买权益或切换账号使用',
      'no_rights_pay': '当前大屏设备「会议纪要」权益已失效，请前往大屏购买权益或切换账号使用',
      'no_rights_translate': '当前大屏设备「实时翻译」权益已失效，请前往大屏购买权益或切换账号使用',
      'unknown_error': '启动录制失败，请重试',
    };
    return errorMessages[status] || defaultMessage || '启动录制失败';
  };

  return (
    <>
      <div className="flex flex-col items-center flex-1 bg-gradient-to-b from-#FFF5 to-#FFF3 rounded-2 border-1px border-solid border-#FFF ">
        {loading ? (
          <div className="size-16 mt-40 cursor-not-allowed rd-full flex items-center justify-center" style={{ background: "linear-gradient(to bottom, #4981f2, #968AFF)" }}>
            <img
              src={IcRecordFinishLoading}
              className="rotation size-6"
            />
          </div>
        ) : (
          <StartRecordIcon
            className={`w-16 h-16 mt-40 cursor-pointer`}
            onClick={handleStartRecord}
          />
        )}
        <div className="mt-4 text-mx-secondary lh-6 text-size-3.5">
          点击按钮，控制大屏开始录制
        </div>
        <img src={StartRecordViewImg} className="w-120 h-29.5 mt-14" />
      </div>

      {/* 启动录制失败弹框 */}
      <StartRecordErrorDialog ref={errorDialogRef} />
    </>
  );
};

export default ControlStartView;
